import styled from 'styled-components';

interface MarkdownContentProps {
	isMobile?: boolean;
}

export const MarkdownContent = styled.div<MarkdownContentProps>`
	user-select: text;
	cursor: text;
	display: flex;
	flex-direction: column;
	gap: 2px;

	h1 {
		font-size: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
		font-weight: 600;
		margin-top: 8px;
		margin-bottom: 8px;
	}

	h2 {
		font-size: ${({ isMobile }) => (isMobile ? '20px' : '17px')};
		font-weight: 600;
		margin-top: 0px;
		margin-bottom: 6px;
		margin-top: 10px;
	}

	h3 {
		font-size: ${({ isMobile }) => (isMobile ? '18px' : '15px')};
		font-weight: 600;
		margin-top: 0px;
		margin-top: 4px;
		margin-bottom: 6px;
	}

	// bullet points
	ul,
	ol {
		margin: 0;
		padding: 0;
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		gap: 4px;
		margin-bottom: 12px;
	}

	li {
		margin: 0;
		padding: 0;
		line-height: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
	}

	// nested bullet points
	ul ul,
	ol ol {
		padding-bottom: 0;
		margin-bottom: 0px;
	}

	li ul,
	li ol {
		margin: 0;
		margin-top: 5px;
		padding: 0;
		padding-left: 20px;
	}

	p {
		margin: 0;
		padding: 0;
		line-height: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
		margin-bottom: 4px;
	}
`;
